const UserStatusEnum = Object.freeze({
    Active : 'active',
    Inactive: 'inactive',
    Suspended: 'suspended',
})

export default UserStatusEnum;